<div class="auto-remove-popover auto-remove-popover--compact">
  <header class="auto-remove-popover__header">
    <span class="auto-remove-popover__icon" aria-hidden="true">
      <mat-icon>autorenew</mat-icon>
    </span>
    <h5 class="auto-remove-popover__title">
      {{ 'stores.autoRemovePopover.title' | translate }}
    </h5>
  </header>

  <section class="auto-remove-popover__body">
    <p class="auto-remove-popover__lead">
      {{ 'stores.autoRemovePopover.description' | translate }}
    </p>
    <p>{{ 'stores.autoRemovePopover.managedByAmazon' | translate }}</p>
  </section>

  <footer class="auto-remove-popover__footer">
    <div class="auto-remove-popover__actions">
      <button
        mat-stroked-button
        type="button"
        class="auto-remove-popover__action"
        (click)="openKnowledgeBase()">
        {{ 'stores.autoRemovePopover.learnMore' | translate }}
      </button>
    </div>
  </footer>
</div>
